// Copy + schedule data for the Take The Stage landing page.
// Real form submission wires to backend later; TidyCal redirect is real.

export const SITE = {
  brand: "Michelle Fragias",
  program: "Take The Stage",
  tagline: "A Signature Talk Accelerator — 6 spots only",
  tidyCalUrl: "https://tidycal.com/michellefragias/take-the-stage",
  bookACallUrl: "https://www.michellefragias.com/consultation",
  instagramUrl: "https://www.instagram.com/michellefragias/",
  linkedinUrl: "https://www.linkedin.com/in/michellefragias/",
  logoWordmark: "Michelle",
  logoSub: "FRAGIAS",
  // Logo variants (webp)
  logoDark: "https://customer-assets-0z36b82j.emergentagent.net/job_stage-booking-2/artifacts/iavg18v0_Final%20Michelle%20Fragias%20Logo%20Design-01-01.webp",   // burgundy — for cream backgrounds
  logoLight: "https://customer-assets-0z36b82j.emergentagent.net/job_stage-booking-2/artifacts/rrzaubn7_Final%20Michelle%20Fragias%20Logo%20Design-01-02%20%281%29.webp", // beige/cream — for dark backgrounds
  logoBlack: "https://customer-assets-0z36b82j.emergentagent.net/job_stage-booking-2/artifacts/f53s877x_Final%20Michelle%20Fragias%20Logo%20Design-01-03.webp",
  logoTeal: "https://customer-assets-0z36b82j.emergentagent.net/job_stage-booking-2/artifacts/lrgmcku8_Final%20Michelle%20Fragias%20Logo%20Design-01-04.webp",
};

export const HERO = {
  eyebrow: "A Signature Talk Accelerator",
  eyebrowSub: "Cohort of 6  |  October 2026",
  headlinePre: "From Story to Stage:",
  headlineMain: "Build the talk. Step onto the stage.",
  headlineItalic: "Be seen for what you know.",
  sub: "A high-touch accelerator for business owners, coaches, and consultants ready to turn their story, message, and expertise into a signature talk they can deliver live on a real stage — with video assets that build visibility and credibility beyond the room.",
  primaryCta: "Apply Now",
  secondaryCta: "See How It Works",
  facts: [
    { k: "Cohort begins", v: "Mon 5 October 2026" },
    { k: "Sydney Intensive", v: "Nov 21–22, 2026" },
    { k: "Investment", v: "$2,997 AUD" },
  ],
  image: "https://images.squarespace-cdn.com/content/v1/692a8a0e540ce57e2f9077eb/a422c563-0ed4-478f-9b53-f5c40b2c9065/MichelleBranding12thMay0535.jpg",
};

export const GAP = {
  eyebrow: "The Gap",
  heading: "You know your message. You've just never had the room to prove it.",
  before: {
    title: "Where you are now",
    items: [
      "Your expertise lives in your head, not in a talk you can deliver",
      "You want to speak on stages but have never delivered to a real audience",
      "No footage, no proof, no way to pitch yourself to event organisers",
      "Your story and your business feel like two disconnected things",
    ],
  },
  after: {
    title: "After Take The Stage",
    items: [
      "A built, rehearsed signature talk that connects your story to your business",
      "A live delivery in front of a real audience at Show Night",
      "Professional video assets you can use to pitch stages, clients, and podcasts",
      "Visibility and credibility that compounds long after the room empties",
    ],
  },
  footer: "This isn't a workshop about speaking. It's eight weeks of building, two days of in-room delivery, and one live showcase where you step onto a real stage.",
};

export const INSIDE = {
  eyebrow: "What's Inside",
  heading: "Everything you need to go from idea to stage-ready talk",
  items: [
    { title: "8 Weeks of Talk Building", body: "Structured live training to develop your signature talk — from raw story to a clear, compelling talk you can deliver with presence, using the B.R.A.V.E. method." },
    { title: "2-Day Sydney Intensive", body: "Two intensive days in-room (Nov 21–22) to rehearse, refine and pressure-test your talk before you deliver it live." },
    { title: "Professional Video Assets", body: "Your Show Night delivery is professionally filmed — walk away with footage you can use for stages, sales pages and pitches." },
    { title: "A Real Live Audience", body: "No practising into a webcam. You deliver in front of a genuine room on Show Night — the pressure that makes the talk stick." },
    { title: "Small, High-Touch Cohort", body: "Capped at 6 people. This is coaching, not a course — every talk gets real attention and real feedback." },
    { title: "Story-to-Business Bridge", body: "We connect your personal story directly to your business positioning, so the talk builds your brand, not just your confidence." },
  ],
};

export const SCHEDULE = {
  eyebrow: "The Program",
  heading: "How the eight weeks run",
  weeks: [
    { label: "Week 1",  date: "Monday 5 October 2026",       time: "5:00pm AEST", title: "Live Call — Find the Story (I)",     body: "Kick-off. Excavate the story underneath your expertise and connect it to your business." },
    { label: "Week 2",  date: "Monday 12 October 2026",      time: "5:00pm AEST", title: "Live Call — Find the Story (II)",    body: "Story architecture, message DNA, and the hook that opens every talk." },
    { label: "Week 3",  date: "Monday 19 October 2026",      time: "5:00pm AEST", title: "Live Call — Build the Talk (I)",     body: "Structure your signature talk with the B.R.A.V.E. method — arc, message, delivery beats." },
    { label: "Week 4",  date: "Monday 26 October 2026",      time: "5:00pm AEST", title: "Live Call — Build the Talk (II)",    body: "Refine the middle, land the close, embed proof and payoff throughout." },
    { label: "Week 5",  date: "Monday 2 November 2026",      time: "5:00pm AEST", title: "Live Call — Rehearse & Refine",      body: "First full run-throughs. Live coaching and feedback rounds." },
    { label: "Week 6",  date: "9–15 November 2026",           time: "Self-paced",   title: "Practice / Refine / Catch-Up Week", body: "Space to embed the reps, rework sticky sections, and prep for delivery." },
    { label: "Week 7",  date: "Monday 16 November 2026",     time: "5:00pm AEST", title: "Live Call — Final Rehearsal",        body: "Pressure-test the delivery. Final refinements before we get in the room." },
    { label: "Week 8",  date: "Sat 21 – Sun 22 November 2026", time: "Sydney",      title: "2-Day Sydney Intensive",           body: "Two intensive days in-room to finalise delivery and pressure-test live." },
    { label: "Show Night", date: "Sunday 22 November 2026",  time: "5–8pm Sydney", title: "Live Stage + Professional Filming", body: "Step onto a real stage in front of a live audience. Filmed for footage you own." },
  ],
};

export const SHOW_NIGHT = {
  eyebrow: "The Payoff",
  heading: "Show Night is the point of the whole program",
  sub: "Everything you build in eight weeks leads to one night, one stage, one audience.",
  points: [
    { n: "1", title: "You deliver live", body: "Not a rehearsal, not a Zoom room — a real stage, a real audience, in Sydney." },
    { n: "2", title: "It's professionally filmed", body: "Broadcast-quality footage of your talk, ready to use for promotion, pitching and proof." },
    { n: "3", title: "You leave with proof, not just practice", body: "Video assets and a delivered talk you can point to for years — not a certificate that sits in a drawer." },
  ],
};

export const STATS = [
  { big: "NOV 22", small: "Show Night — Live Stage + Filming" },
  { big: "5–8pm", small: "Sydney" },
  { big: "6", small: "Spots per cohort" },
  { big: "8", small: "Weeks of training" },
  { big: "1", small: "Live stage, filmed" },
  { big: "$2,997", small: "AUD investment" },
];

export const IS_THIS_YOU = {
  eyebrow: "Is This You",
  heading: "Built for the person ready to be seen",
  items: [
    "Business owners building visibility and credibility in their market",
    "Coaches and consultants with expertise but no signature talk yet",
    "Service providers who want to speak on stages but have never been trained or tested live",
    "Leaders who know their story is connected to their business — but can't yet see how",
  ],
};

export const INVESTMENT = {
  eyebrow: "The Investment",
  heading: "One cohort. One stage. One clear investment.",
  cohort: "October 2026 Cohort",
  price: "$2,997",
  currency: "AUD",
  spots: "Only 6 places available",
  bullets: [
    "6 live calls across October and November",
    "1 practice and refine week",
    "2-day in-person Sydney intensive on 21–22 November",
    "Live stage delivery at Show Night on 22 November",
    "Professional video footage and photos of your talk",
    "High-touch coaching in a cohort capped at 6",
  ],
};

export const FAQ = [
  { q: "Do I need previous speaking experience to join?", a: "No. Most people joining have never delivered a talk to a real audience before. That is exactly what the eight weeks of training and the Sydney intensive are for — we build your talk and your delivery from the ground up." },
  { q: "What happens at Show Night on November 22?", a: "You step onto a real stage in front of a live audience and deliver the signature talk you have built over the eight weeks. It runs from 5pm to 8pm and is professionally filmed, so you leave with footage you can use to pitch stages, clients, and podcasts." },
  { q: "Do I need to attend the Sydney intensive in person?", a: "Yes. The 2-day intensive on November 21–22 and Show Night on the evening of the 22nd are in-person in Sydney. This is where the talk gets pressure-tested and delivered live, so being in the room is part of the program." },
  { q: "Why is the cohort capped at 6 spots?", a: "This is high-touch coaching, not a course. With only 6 spots per cohort, every talk gets real feedback across the eight weeks and real attention during the intensive." },
  { q: "What do I actually walk away with?", a: "A built and rehearsed signature talk, a live delivery on a real stage, and professional video footage of that delivery — proof you can use well beyond the room, on your website, in pitches, and to book future stages." },
];
